import React from 'react';

var Tick = function Tick(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4.29 15.19l3.13 3.162a2.328 2.328 0 0 0 3.5-.217L19.791 6.61a1 1 0 1 0-1.584-1.22L9.335 16.915c-.158.16-.366.16-.493.03L5.71 13.782a1 1 0 1 0-1.422 1.407z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Tick.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { Tick as icon };
export default iconHandler(Tick);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/Tick.js
// module id = 627
// module chunks = 0